import messages from '../CommonTranslations/messages';

export default messages;
